import {
    SET_TAB_SELECTION,
    GET_PERMISSIONS,
    SET_PERMISSIONS,
    SET_USER_TAB,
} from "./types";
import firebase from "firebase/app";
import pageKeys from "./pagekeys.json";
export const setTabSelection = (tab = "Level 1") => {
    return (dispatch) => {
        dispatch({ type: SET_TAB_SELECTION, payload: tab });
    };
};
export const setUserType = (tab = "User") => {
    return (dispatch) => {
        dispatch({ type: SET_USER_TAB, payload: tab });
    };
};
export const getPermissions = () => {
    return (dispatch) => {
        dispatch({ type: GET_PERMISSIONS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_PERMISSIONS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/level_permissions")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_PERMISSIONS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_PERMISSIONS.FAIL });
        }
    };
};
export const initializeAccessLevels = () => {
    return (dispatch) => {
        dispatch({ type: SET_PERMISSIONS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: SET_PERMISSIONS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/report_titles")
                        .on("value", (snapshot) => {
                            let titles = snapshot.val();
                            let access = loadDataModel(titles);
                            firebase
                                .database()
                                .ref("/collections/level_permissions")
                                .set(access);
                            dispatch({
                                type: SET_PERMISSIONS.SUCCESS,
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: SET_PERMISSIONS.FAIL });
        }
    };
};
const loadDataModel = (titles) => {
    let levelRest = {};
    let levelNoRest={};
    //loop through pagekeys
    Object.keys(pageKeys).map((e) => {
        let crud = {
            read: true,
            create: [
                "machine_manager",
                "equipment_manager",
                "user_manager",
            ].includes(e)
                ? false
                : true,
            share: true,
            title: pageKeys[e].title,
            key: e,
            delete: [
                "machine_manager",
                "equipment_manager",
                "user_manager",
            ].includes(e)
                ? false
                : true,
            update: true,
            top: pageKeys[e].top,
        };
        let crudNoRest = {
            read: true,
            create: true,
            share: true,
            title: pageKeys[e].title,
            key: e,
            delete: true,
            update: true,
            top: pageKeys[e].top,
        };
        levelRest = { ...levelRest, [e]: crud };
        levelNoRest = {...levelNoRest,[e]:crudNoRest}
        return null;
    });
    //loop through report titles
    if (titles)
        Object.keys(titles).map((e) => {
            let crud = {
                read: true,
                create: true,
                share: true,
                title: titles[e],
                delete: true,
                update: true,
                key: e,
                top: false,
            };
            levelRest = { ...levelRest, [e]: crud };
            levelNoRest = {...levelNoRest,[e]:crud}
            return null;
        });
    let Levels = {
        "Level 1": levelRest,
        "Level 2": levelRest,
        "Level 3": levelRest,
        "Level 4": levelRest,
        Equipment: levelNoRest,
        User: levelNoRest,
        Plant: levelNoRest,
        Client: levelNoRest,
        Contractor: levelNoRest,
    };
    return Levels;
};
export const saveChanges = (permissions) => {
    return (dispatch) => {
        dispatch({ type: SET_PERMISSIONS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: SET_PERMISSIONS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/level_permissions")
                        .set(permissions);
                    dispatch({
                        type: SET_PERMISSIONS.SUCCESS,
                    });
                }
            });
        } catch (e) {
            dispatch({ type: SET_PERMISSIONS.FAIL });
        }
    };
};
